export default __webpack_public_path__ + "static/media/review.56570f4e.svg";